import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'
import DashboardHomePage from '../components/dashboard/DashboardHomePage'
import { actionCreators } from '../state/state-index'
import Private from './Private'

const Dashboard = () => {
  const dispatch = useDispatch()
  const { cleanDaysState } = bindActionCreators(actionCreators, dispatch)

  cleanDaysState(true)
  const { t } = useTranslation()
  return (
    <Private>
      <Helmet>
        <title>Koç Office Free - {t('browser-header.statistic')}</title>
      </Helmet>
      <div className="container">
        <DashboardHomePage />
      </div>
    </Private>
  )
}

export default Dashboard
